module.exports = __webpack_public_path__ + "static/img/coins_order_bg.1d85232.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/coins_order_bg.jpg
// module id = oO2R
// module chunks = 1